var searchForm = document.getElementById("search-form");
var filterby = document.getElementById("filter-by");
var formOpen = document.getElementById("form-open");
var dropinlist = document.querySelector(".main-blog-blogs-dropin-list");
var closebtn = document.querySelector(".main-blog form .close-btn");
var rotate = document.querySelector(".main-blog-filter svg");
var submitbtn = document.querySelector(".main-blog form input[type=submit]");

var body = document.body;

if (window.innerWidth < 568) {
  if(formOpen){
    formOpen.addEventListener("click", function(event) {
      searchForm.style.display = searchForm.style.display === "none" ? "flex" : "none";
      closebtn.style.display =searchForm.style.display === "none"  ? "none" : "block";      
      // Prevent event from propagating to the document
      event.stopPropagation();
    });
  }
  if(closebtn){
  closebtn.addEventListener("click", function(event) {
    searchForm.style.display = "none";
    searchForm.reset();
  });
}
  if(filterby){
    filterby.addEventListener("click", function(event) {
      dropinlist.style.display = dropinlist.style.display === "none" ? "flex" : "none";
      dropinlist.style.opacity =  dropinlist.style.display === "none" ? '0' : '1';
      rotate.style.transform  = dropinlist.style.display === "none"  ? "none" : "rotate(180deg)";
    });
    
}


}